import { useContext } from 'react'
import { SidePanelContext } from 'contexts'

export const useSidePanel = () => {
  const { state, dispatch } = useContext(SidePanelContext)

  return {
    state,
    dispatch,
  }
}
